import React from 'react';
import ProgramCard from '../../../shared/ProgramCard/ProgramCard';
import Section from '../../../shared/Section/Section';
import { useBackgroundsQuery } from '../../../app/queries/backgrounds.query';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Box, useMediaQuery, Typography } from '@mui/material';

const Bg = ({ bg, img }) => {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        transform: 'translateZ(0)',
      }}
    >
      <GatsbyImage
        style={{
          width: '100%',
          height: '100%',
          position: 'relative',
          border: 'solid 1px gray',
          borderRadius: 16,
          overflow: 'hidden',
        }}
        imgStyle={{
          width: '100%',
          height: '100%',
        }}
        image={getImage(bg)}
        alt=""
        loading="lazy"
      />
      <GatsbyImage
        style={{
          width: isSm ? '40%' : '45%',
          height: isSm ? '40%' : '45%',
          position: 'absolute',
          bottom: 24,
          right: 24,
          zIndex: 0,
        }}
        image={getImage(img)}
        alt=""
        loading="lazy"
      />
    </Box>
  );
};
export default function Programs({
  title,
  subtitle,
  data: { main, secondary },
  extraLeadData,
}) {
  const { bgImgs } = useBackgroundsQuery();
  const isMd = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const useColumnLayout = useMediaQuery('(max-width:1400px)');

  return (
    <Section
      title={title}
      subtitle={subtitle}
      theme="medium"
      anchor="program"
      bg={'programcards'}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: useColumnLayout ? 'column' : 'row',
          gap: useColumnLayout ? '24px' : '16px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: useColumnLayout ? '16px' : '24px',
          }}
        >
          <Typography variant="desktopH3" color="#0F0F0F">
            Основные
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: isMd ? 'column' : 'row',
              gap: '16px',
            }}
          >
            {main.map((program, index) => {
              const bgPath = `backgrounds/program-card-${program.program.toLowerCase()}`;
              const imgPath = `backgrounds/program-card-${program.program.toLowerCase()}-pic`;

              return (
                <ProgramCard
                  key={index}
                  bg={<Bg bg={bgImgs[bgPath]} img={bgImgs[imgPath]} />}
                  program={program}
                  extraLeadData={extraLeadData}
                />
              );
            })}
            <Box
              sx={{
                display: useColumnLayout ? 'none' : 'block',
                width: '1px',
                height: '100%',
                border: '1px solid rgba(17, 17, 17, 0.5)',
              }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: useColumnLayout ? '16px' : '24px',
          }}
        >
          <Typography variant="desktopH3" color="#0F0F0F">
            Повышение квалификации
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: useColumnLayout ? 'column' : 'row',
              gap: '16px',
            }}
          >
            {secondary.map((program, index) => {
              const bgPath = `backgrounds/program-card-${program.program.toLowerCase()}`;
              const imgPath = `backgrounds/program-card-${program.program.toLowerCase()}-pic`;

              return (
                <ProgramCard
                  key={index}
                  bg={<Bg bg={bgImgs[bgPath]} img={bgImgs[imgPath]} />}
                  program={program}
                  extraLeadData={extraLeadData}
                />
              );
            })}
          </Box>
        </Box>
      </Box>
    </Section>
  );
}
